import {ModifierModel} from './Modifier.model';
import {ModifierGroup} from '@wix/auto_sdk_ecom_current-cart';
import {ModelContext} from '../../types/app.types';

export class ModifierGroupModel {
  public id: string;
  public name?: string;
  public modifiers: ModifierModel[];

  constructor(params: ModifierGroupModel) {
    this.id = params?.id;
    this.name = params?.name;
    this.modifiers = params?.modifiers;
  }

  public static fromSDK(modifierGroup: ModifierGroup, modelContext: ModelContext): ModifierGroupModel {
    return new ModifierGroupModel({
      id: modifierGroup._id,
      name: modifierGroup.name?.translated ?? modifierGroup.name?.original ?? /* istanbul ignore next */ undefined,
      modifiers: (modifierGroup.modifiers ?? []).map((modifier) => ModifierModel.fromSDK(modifier, modelContext)),
    });
  }
}
